export default __webpack_public_path__ + "static/openocean-31878ea76ffbdf2013ab0a674e859145.svg";